import React from "react";
import { useNavigate } from "react-router-dom";
import { Table, Tag, Button, Tooltip, Popconfirm, Space, Switch } from "antd";
import {
  AppstoreAddOutlined,
  EditOutlined,
  DeleteOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

const TemplatesTable = ({
  templates,
  loading,
  onManageItems,
  onEdit,
  onDelete,
  onToggleStatus,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a onClick={() => onManageItems(record)}>{text}</a>
      ),
    },
    {
      title: "Class",
      dataIndex: "class_name",
      key: "class_name",
      render: (text) => text || "N/A",
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      render: (text) => text || "N/A",
    },
    {
      title: "Academic Year",
      dataIndex: "acadyr",
      key: "acadyr",
    },
    {
      title: "Items",
      dataIndex: "requirement_items",
      key: "requirement_items",
      render: (items) => <Tag color="blue">{items?.length || 0} items</Tag>,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      align: "center",
      render: (isActive, record) => (
        <Tooltip
          title={isActive === 1 ? "Click to deactivate" : "Click to activate"}
        >
          <Switch
            checked={isActive === 1}
            onChange={() => onToggleStatus(record.id, isActive)}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
          />
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Manage Items">
            <Button
              type="link"
              icon={<AppstoreAddOutlined />}
              onClick={() => onManageItems(record)}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Assign to Students">
            <Button
              type="link"
              icon={<UserAddOutlined />}
              onClick={() => {
                navigate("/admin/bot/assignments", {
                  state: { templateId: record.id },
                });
              }}
            />
          </Tooltip>
          <Popconfirm
            title="Are you sure you want to delete this template?"
            description="This action cannot be undone."
            onConfirm={() => onDelete(record.id)}
            okText="Yes, Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Delete Template">
              <Button type="link" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={templates}
      rowKey="id"
      loading={loading}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} templates`,
      }}
      scroll={{ x: 900 }}
    />
  );
};

export default TemplatesTable;
